import { toBrokerOption } from '@/bundles/Dashboards/mappers';
import {
  IPipelineDashboardFilterOptions,
  IPipelineDashboardFilterOptionsGetOne,
} from '@/bundles/Pipeline/types';

export function mapPipelineDashboardFilterOptions (
  response: IPipelineDashboardFilterOptionsGetOne,
): IPipelineDashboardFilterOptions {
  return {
    broker: (response.brokers ?? []).map(toBrokerOption),
  };
}
